import { Row, Col, Card, CardBody, Label, Button } from 'reactstrap';
import { VerificationState } from '../../../features/ingest/ingestSlice';
import verificationActions from '../../../features/ingest/verificationActions';
import mappingActions from '../../../features/ingest/mappingActions';
import { useDispatch } from 'react-redux';
import ErrorSummary from './ErrorSummary';

export default (state: VerificationState) => {
  const verifyActions = new verificationActions(useDispatch());
  const mapActions = new mappingActions(useDispatch());
  if (
    state.verificationSuccess &&
    state.rowsWithErrors == 0 &&
    state.numberOfDuplicateRows == 0
  ) {
    return (
      <>
        <Row className="justify-content-center">
          <div>No erroneous rows or potential duplicates found!</div>
        </Row>
        <Row className="justify-content-center mb-5 mt-3">
          <Button
            className="btn-cta"
            onClick={() => verifyActions.approveVerificationReport(state)}
          >
            Finish Uploading
          </Button>
        </Row>
        <Row className="justify-content-end mb-2 mt-5">
          <Col md="auto" className="mr-auto">
            {state.isCancellable && (
              <Button onClick={() => verifyActions.cancelVerification(state)}>
                Cancel
              </Button>
            )}
          </Col>
        </Row>
        ;
      </>
    );
  } else {
    return (
      <>
        <Row className="tpicap-semibold-label justify-content-start ml-3 pb-5">
          <div>
            We have identified that the following rows may potentially contain erroneous data. (One row may contain more than one row-level error).
            Please review the validation report below.
          </div>
        </Row>
        <ErrorSummary {...state} />
        <Row className="tpicap-important-text justify-content-start ml-3 pt-5 pb-5 text-danger">
          <div>
            Erroneous rows will be excluded from the upload. Only one row from
            each set of potential duplicates will be included in the upload.
          </div>
        </Row>
        <Row className="justify-content-end">
          <Col md="auto">
            {state.isCancellable && (
              <Button
                className="mr-2"
                onClick={() => verifyActions.cancelVerification(state)}
              >
                Cancel Upload
              </Button>
            )}
            <Button
              className="mr-2 btn-cta"
              onClick={() => verifyActions.approveVerificationReport(state)}
            >
              Continue to Upload File
            </Button>
          </Col>
        </Row>
      </>
    );
  }
};
